import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import './DroneGame.css';
import yellowDrone from '../assets/images/drone-game/drone-yellow.png';
import redDrone from '../assets/images/drone-game/drone-red.png';
import blueDrone from '../assets/images/drone-game/drone-blue.png';

import topBar from '../assets/images/drone-game/top-bar.png'
import controllerImage from '../assets/images/drone-game/controller.png'
import arrowUpImage from '../assets/images/drone-game/arrow-up.png'
import arrowDownImage from '../assets/images/drone-game/arrow-down.png'
import waterBtn from '../assets/images/drone-game/water-btn.png'
import batteryImage from '../assets/images/drone-game/battery.png'
import bombImage from '../assets/images/drone-game/bomb.png'
import windGif from '../assets/images/drone-game/wind.gif'
import addTen from '../assets/images/drone-game/add-10.png'
import removeOne from '../assets/images/drone-game/remove-1.png'
import removeTen from '../assets/images/drone-game/remove-10.png'

import gameOverTimeout from '../assets/images/drone-game/drone-timeout.png'
import gameOverBroken from '../assets/images/drone-game/drone-broken.png'

import Confetti from 'react-dom-confetti';

const drones = [ yellowDrone, redDrone, blueDrone ]

const config = {
    angle: "241",
    spread: "77",
    startVelocity: 40,
    elementCount: "150",
    dragFriction: "0.21",
    duration: "2000",
    stagger: "6",
    width: "1vh",
    height: "1vh",
    perspective: "500px",
    colors: [ "#81bef4" , "#5ad8f9", "#1b5ebe" ]
};

const MOUNTAIN_SPLITTER = [ 0.1, 0.4, 0.7, 1.0, 0.7, 0.4, 0.1 ]
const OBJECT_SPLITTER = [ 0.0, 1.0, 0.0 ]
const FADE_OUT_SPACING = 0.35;
const OPACITY_INTERVAL = 300;

function createRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

class DroneGame extends Component {

    btnSound = './sounds/button_sound.mp3';
    arrowBtnSound = './sounds/arrow_btn.mp3';
    collisionSound = './sounds/collision.mp3';
    windSound = './sounds/wind.mp3';
    birdAttackSound = './sounds/bird_attack.mp3';
    dropWaterSound = './sounds/drop_water.mp3';

    maxHeight = -450;
    minHeight = -60;
    maxSpeed = 10;
    minSpeed = 1;
    countdownInterval = null;
    bombInterval = null;
    addTenInterval = null;
    removeTenInterval = null;
    removeOneInterval = null;
    
    constructor(props) {
        super(props);
        this.state = {
            droneImage: drones[this.props.location.state.selectedIndex],
            countdown: 60,
            battery: 3,
            playing: false,
            spray: false,
            baseSpeed: 5,
            additionSpeed: 0,
            distance: 0,
            score: 100,
            bgOffset: 0,
            itemOffset: 0,
            bombOpacity: 0.0,
            objects: this.createRenderObject(),
            playerVerticalPosition: -250,
            playerHorizontalPosition: 0,
            gameOverTimeout: false,
            gameOverBroken: false,
            addTenOpacity: 0.0,
            removeTenOpacity: 0.0,
            removeOneOpacity: 0.0
        };

        this.domRefs = {}; // to store dom refs
        this.animateElements = this.animateElements.bind(this);
    }

    startAddTen() {
        if (this.addTenInterval !== null) {
            clearInterval(this.addTenInterval);
        }
        if (this.removeTenInterval !== null) {
            clearInterval(this.removeTenInterval);
            this.setState({
                removeTenOpacity: 0.0
            })
        }
        this.setState({
            addTenOpacity: 1.0
        });
        this.addTenInterval = setInterval(() => {
            if (this.state.addTenOpacity >= 0) {
                this.setState({
                    addTenOpacity: this.state.addTenOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.addTenInterval)
                this.addTenInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startRemoveTen() {
        if (this.addTenInterval !== null) {
            clearInterval(this.addTenInterval);
            this.setState({
                addTenOpacity: 0.0
            });
        }
        if (this.removeTenInterval !== null) {
            clearInterval(this.removeTenInterval);
        }
        this.setState({
            removeTenOpacity: 1.0
        });
        this.removeTenInterval = setInterval(() => {
            if (this.state.removeTenOpacity >= 0) {
                this.setState({
                    removeTenOpacity: this.state.removeTenOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.removeTenInterval)
                this.removeTenInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startRemoveOne() {
        if (this.addOneInterval !== null) {
            clearInterval(this.addOneInterval);
        }
        this.setState({
            removeOneOpacity: 1.0
        });
        this.addOneInterval = setInterval(() => {
            if (this.state.removeOneOpacity >= 0) {
                this.setState({
                    removeOneOpacity: this.state.removeOneOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.addOneInterval)
                this.addOneInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startBomb() {
        if (this.bombInterval !== null) {
            clearInterval(this.bombInterval);
        }
        this.bombInterval = setInterval(() => {
            if (this.state.bombOpacity >= 0) {
                this.setState({
                    bombOpacity: this.state.bombOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.bombInterval)
            }
        }, OPACITY_INTERVAL);
    }

    checkBatteryToGameOver() {
        if (this.state.battery <= 0) {
            this.setState({
                gameOverBroken: true
            });
            this.gameOver();
        }
    }

    createRenderObject() {

        let lastPercent = 3000;
        let obj = [];

        // create eagle, from 100%, left distance = 60% ~ 100%, bottom distance = 30% ~ 65%
        let startPercent = 50
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(80, 150);
            let verDistance = createRandomNumber(30, 65);
            obj.push(this.createEagleObject(startPercent.toString() + '%', verDistance.toString() + '%'));
        }

        // create mountain
        startPercent = 20;
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(70, 120);
            let mode = createRandomNumber(1, 100);
            if (mode % 2 === 0) {
                obj.push(this.createMountain1Object(startPercent.toString() + '%'))
                startPercent += createRandomNumber(15, 35);
                obj.push(this.createMountain2Object(startPercent.toString() + '%'))
                startPercent += createRandomNumber(15, 35);
                obj.push(this.createMountain3Object(startPercent.toString() + '%'))
            } else {
                if (mode < 33) {
                    obj.push(this.createMountain1Object(startPercent.toString() + '%'))
                } else if (mode < 66) {
                    obj.push(this.createMountain2Object(startPercent.toString() + '%'))
                } else {
                    obj.push(this.createMountain3Object(startPercent.toString() + '%'))
                }
            }
        }

        // create wind
        startPercent = createRandomNumber(150, 250)
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(150, 300);
            obj.push(this.createWindObject(startPercent.toString() + '%'))
        }

        // create wanted water
        startPercent = createRandomNumber(30, 100);
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(80, 160);
            obj.push(this.createWantWaterObject(startPercent.toString() + '%'))
        }

        return obj;
    }

    createEagleObject(left, bottom) {
        return { 
            bottom: bottom, 
            left: left, 
            touched: false, 
            tag: 1 
        }
    }

    createWindObject(left) {
        return { 
            bottom: '0px', 
            left: left, 
            touched: false,
            delay: false,
            tag: 6 
        }
    }

    createMountainObject(left, tag) {
        return { 
            bottom: '5%', 
            left: left, 
            touched: false, 
            delay: false,
            tag: tag
        }
    }

    createMountain1Object(left) {
        return this.createMountainObject(left, 3);
    }

    createMountain2Object(left) {
        return this.createMountainObject(left, 4);
    }

    createMountain3Object(left) {
        return this.createMountainObject(left, 5);
    }

    createWantWaterObject(left) {
        return { 
            bottom: '9%', 
            left: left, 
            touched: false, 
            delay: false,
            tag: 2 
        }
    }

    getBounds(ref) {
        let element = ReactDOM.findDOMNode(ref);
        return (element === null || element === undefined) ? null : ReactDOM.findDOMNode(ref).getBoundingClientRect();
    }

    detectSprayCollision(a, b) {
        if (a === null || b === null) return false;
        return !(
            ((a.x + a.width) < b.x) ||
            (a.x > (b.x + b.width))
        );
    }

    detectCollision(a, b) {
        if (a === null || b === null) return false;
        return !(
            ((a.y + a.height) < (b.y)) ||
            (a.y > (b.y + b.height)) ||
            ((a.x + a.width) < b.x) ||
            (a.x > (b.x + b.width))
        );
    }

    detectMountainCollision(a, b) {
        if (a === null || b === null) return false;
        const elementWidth = b.width / MOUNTAIN_SPLITTER.length;
        for (let i = 0; i < MOUNTAIN_SPLITTER.length; i++) {
            let elementHeight = b.height * MOUNTAIN_SPLITTER[i];
            let element = {
                x: b.x + (elementWidth * i),
                y: b.y + (b.height - elementHeight),
                width: elementWidth,
                height: elementHeight
            }
            if (this.detectCollision(a, element)) {
                return true;
            }
        }
        return false;
    }

    detectObjectCollision(a, b) {
        if (a === null || b === null) return false;
        const elementWidth = b.width / OBJECT_SPLITTER.length;
        for (let i = 0; i < OBJECT_SPLITTER.length; i++) {
            if (OBJECT_SPLITTER[i] > 0) {
                let elementHeight = b.height * OBJECT_SPLITTER[i];
                let element = {
                    x: b.x + (elementWidth * i),
                    y: b.y + (b.height - elementHeight) / 2,
                    width: elementWidth,
                    height: elementHeight
                }
                if (this.detectCollision(a, element)) {
                    return true;
                }
            }
        }
        return false;
    }

    animateElements() {

        let gameSpeed = this.state.baseSpeed + this.state.additionSpeed;

        // increase speed
        // let speed = (this.state.distance / 5) + 5;
        // this.setState({ gameSpeed: speed });

        if (this.state.playing === true) {
            this.setState({
                bgOffset: this.state.bgOffset >= window.innerWidth ? 0 : this.state.bgOffset + (0.5 * gameSpeed),
                itemOffset: this.state.itemOffset + (0.7 * gameSpeed),
                distance: this.state.distance + 0.01
            });

            let playerRect = this.getBounds(this.refs.player);
            if (playerRect != null) {
                let newState = this.state;
                let changed = false;
                Object.keys(this.state.objects).forEach((item) => {
                    let obj = this.state.objects[item];
                    if (obj != null && obj.touched === false) {
                        let rect = this.getBounds(this.domRefs[item]);
                        if (rect != null) {
                            if (obj.tag === 2) {
                                if (this.state.spray && this.detectSprayCollision(playerRect, rect)) {
                                    this.setState({ score: this.state.score + 10 })
                                    this.startAddTen();
                                    newState.objects[item].touched = true;
                                    changed = true;
                                }
                            } else if (obj.tag === 3 || obj.tag === 4 || obj.tag === 5) {
                                if (this.detectMountainCollision(playerRect, rect)) {
                                    this.setState({
                                        battery: this.state.battery - 1,
                                        score: this.state.score - 10,
                                        bombOpacity: 1.0
                                    });
                                    this.startRemoveOne();
                                    this.startRemoveTen();
                                    this.playCollisionBtnSound();
                                    this.startBomb();
                                    newState.objects[item].touched = true;
                                    changed = true;
                                    this.checkBatteryToGameOver();
                                }
                            } else {
                                if (this.detectObjectCollision(playerRect, rect)) {
                                    if (obj.tag === 6) {
                                        setTimeout(() => { this.windDown() }, 0.5 * 1000);
                                    } else {
                                        if (obj.tag === 1) {
                                            this.setState({
                                                battery: this.state.battery - 1,
                                                score: this.state.score - 10,
                                                bombOpacity: 1.0
                                            })
                                            this.startRemoveOne();
                                            this.startRemoveTen();
                                            this.playCollisionBtnSound();
                                            this.startBomb();
                                            this.checkBatteryToGameOver();
                                        } else {
                                            this.setState({ 
                                                score: this.state.score + (obj.tag === 0 ? 10 : -10)
                                            })
                                            if (obj.tag === 0) {
                                                this.startAddTen();
                                            } else {
                                                this.startRemoveTen();
                                            }
                                        }
                                    }
                                    newState.objects[item].touched = true;
                                    changed = true;
                                }
                            }
                        }
                    }
                })
                if (changed) {
                    this.setState({ newState })
                }
            }
        }
        requestAnimationFrame(this.animateElements);
    }

    gameOver() {
        this.setState({
            playing: false
        });
        setTimeout(() => {
            this.props.history.push({
                pathname: './score',
                state: {
                    score: this.state.score < 0 ? 0 : this.state.score,
                    selectedIndex: this.props.location.state.selectedIndex,
                }
            });
        }, 1000 * 1.5);
    }

    getItemFromTag(tag) {
        if (tag === 0) {
            return 'coin-item ';
        } else if (tag === 1) {
            return 'block-item ';
        } else if (tag === 2) {
            return 'ground-item '
        } else if (tag === 3) {
            return 'mountain-item-1 '
        } else if (tag === 4) {
            return 'mountain-item-2 '
        } else if (tag === 5) {
            return 'mountain-item-3 '
        } else if (tag === 6) {
            return 'wind-item '
        } else {
            return ''
        }
    }

    objectRender(key) {
        let item = this.state.objects[key];
        let styles = {
            transform: 'translate3d(-' + this.state.itemOffset + 'px, 0, 0)', 
            bottom: item.bottom, 
            left: item.left,
        }
        let name = this.getItemFromTag(item.tag)
        if (name === 'wind-item ') {
            return ( 
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                        <img alt='' src={windGif} style={{ position: 'absolute', left: '0px', top: '10%', width: '100%', objectFit: 'contain' }}></img>
                </div>)
        } else if (name === 'ground-item ') {
            return ( 
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                        <div></div>
                </div>)
        } else if (name === 'block-item ') {
            return (
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                        <div></div>
                </div>)
        } else {
            return ( 
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                </div>)
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions()
        window.addEventListener('keypress', this.keyPress);
        let starting = setInterval(() => {
            let x = this.state.playerHorizontalPosition;
            if (x >= 120) {
                clearInterval(starting);
                this.setState({ playing : true }) 
                requestAnimationFrame(this.animateElements)
            } else {
                this.setState({
                    playerHorizontalPosition: x + 1
                });
            }
        }, 5);
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                this.setState({
                    gameOverTimeout: true
                });
                this.gameOver();
            } else {
                this.setState({
                    countdown: this.state.countdown - 1
                });
            }
        }, 1 * 1000);
    }

    componentWillUnmount() {
        this.setState({ playing : false }) 
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('keypress', this.keyPress);
        cancelAnimationFrame(this.animateElements)
        clearInterval(this.countdownInterval);  
    }

    keyPress = (event) => {
        if (event.key === 'w') {
            (event).preventDefault();
            this.goUp();
        } else if (event.key === 's') {
            (event).preventDefault();
            this.goDown();
        } else if (event.key === 'd') {
            (event).preventDefault();
            this.speedUp()
        } else if (event.key === 'a') {
            (event).preventDefault();
            this.speedDown()
        } else if (event.key === 'z') {
            (event).preventDefault();
            this.spray()
        }
    };

    goUp() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position - 15 >= this.maxHeight) {
                this.setState({
                    playerVerticalPosition: position - 15
                });
            }
        }
    }

    goDown() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position + 15 <= this.minHeight) {
                this.setState({
                    playerVerticalPosition: position + 15
                });
            }
        }
    }

    windDown() {
        if (this.state.playing === true) {
            this.playWindSound()
            let position = this.state.playerVerticalPosition;
            if (position + 30 <= this.minHeight) {
                this.setState({
                    playerVerticalPosition: position + 30
                });
            }
        }
    }

    speedUp() {
        if (this.state.playing === true) {
            this.setState({
                additionSpeed: this.state.additionSpeed + 0.5 > 10 ? 10 : this.state.additionSpeed + 0.5
            });
        }
    }

    speedDown() {
        if (this.state.playing === true) {
            this.setState({
                additionSpeed: this.state.additionSpeed - 0.5 < 0 ? 0 : this.state.additionSpeed - 0.5
            });
        }
    }

    spray() {
        if (this.state.playing === true) {
            this.playDropWaterSound()
            this.setState({
                spray: true
            });
            setTimeout(() => {
                this.setState({
                    spray: false
                });
            }, 100);
        }
    }

    updateDimensions = () => {
        console.log('width: ' + window.innerWidth);
        console.log('height: ' + window.innerHeight);
        this.setState({
            baseSpeed: window.innerWidth / 160
        });
        console.log(this.state.baseSpeed);
    };

    playArrowBtnSound() {
        //this.playAudio(this.arrowBtnSound);
    }

    playCollisionBtnSound() {
        //this.playAudio(this.collisionSound);
    }

    playWindSound() {
        //this.playAudio(this.windSound);
    }

    playBirdAttackSound() {
        //this.playAudio(this.birdAttackSound);
    }

    playDropWaterSound() {
        //this.playAudio(this.dropWaterSound);
    }

    playAudio(filePath) {
        try {
            let btnAudio = new Audio(filePath);
            btnAudio.play();
        } catch (exception) {
            console.log(exception.message);
        }
    }

    render() {
        let bgStyles = { transform: 'translate3d(-' + this.state.bgOffset + 'px, 0, 0)' }

        return (
            <div className='page-root-div' style={{ position: 'fixed', overflow: 'hidden' }}>
                {Object.keys(this.state.objects).map(key => this.objectRender(key))}
                <div className='game-background' style={bgStyles}/>
                <div className='game-foreground' style={bgStyles}/>
                <div style={{ position: 'absolute', bottom: '0px', left: '0px', height: '16%', width: '19%', transform: 'translate3d(' + (this.state.playerHorizontalPosition + 50) +'%, ' + (this.state.playerVerticalPosition + 50) + '%, 0)' }}>
                    <Confetti active={ this.state.spray } config={ config }/>
                </div>
                <div className='drone-player' ref='player' style={{ transform: 'translate3d(' + this.state.playerHorizontalPosition +'%, ' + this.state.playerVerticalPosition + '%, 0)' }}>
                    <img alt='' src={this.state.droneImage} style={{ position: 'absolute', width: '100%', height: '100%', zIndex: '10', objectFit: 'scale-down' }}></img>
                    <img alt='' src={bombImage} style={{ position: 'absolute', width: '80%', height: '80%', zIndex: '11', objectFit: 'scale-down', opacity: this.state.bombOpacity, right: '0px', bottom: '0px' }}></img>
                </div>
                <div style={{ position: 'absolute', width: '29%', height: '50%', right: '0px', bottom: '0px', zIndex: '1' }}>
                    <img alt='' src={controllerImage} style={{ position: 'absolute', width: '100%' }}></img>
                    <img alt='' className='press-btn' src={arrowUpImage} style={{ position: 'absolute', width: '20%', left: '27%', top: '45%' }} onClick={this.goUp.bind(this)}></img>
                    <img alt='' className='press-btn' src={arrowDownImage} style={{ position: 'absolute', width: '20%', left: '29%', top: '62%' }} onClick={this.goDown.bind(this)}></img>
                    <img alt='' className='press-btn' src={waterBtn} style={{ position: 'absolute', width: '36%', right: '8%', top: '44%' }} onClick={this.spray.bind(this)}></img>
                </div>
                <div style={{ position: 'absolute', left: '0px', top: '3%', height: '10%', width: '100%' }}>
                    <img alt='' src={topBar} style={{ position: 'absolute', height: '100%', left: '50%', transform: 'translate(-50%, 0px)' }}></img>
                    <div style={{ position: 'absolute', right: '42%', top: '30%', width: '6%', height: '50%', color: '#086940' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#086940" >{this.state.countdown}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', right: '4%', top: '30%', width: '6%', height: '50%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="white" >{this.state.score}</text>
                        </svg>
                    </div>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '20%', top: '18%', display: this.state.battery > 2 ? 'block' : 'none' }}></img>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '17%', top: '18%', display: this.state.battery > 1 ? 'block' : 'none' }}></img>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '14%', top: '18%', display: this.state.battery > 0 ? 'block' : 'none' }}></img>
                </div>
                <img alt='' src={addTen} style={{ position: 'absolute', width: '14%', top: '12%', right: '2%', opacity: this.state.addTenOpacity }}></img>
                <img alt='' src={removeTen} style={{ position: 'absolute', width: '14%', top: '12%', right: '2%', opacity: this.state.removeTenOpacity }}></img>
                <img alt='' src={removeOne} style={{ position: 'absolute', width: '14%', top: '10%', left: '10%', opacity: this.state.removeOneOpacity }}></img>
                {
                    this.state.gameOverBroken && <img alt='' src={gameOverBroken} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
                {
                    this.state.gameOverTimeout && <img alt='' src={gameOverTimeout} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
            </div>
        );
    }
}

export default withRouter(DroneGame);
